import React from 'react';

const ContactContent = () => (
    <div>
            <h2>Contact Us</h2>

            <p>We appreciate your interest in reaching out to us. Please feel free to contact us using the information below:</p>

            <h3>Email:</h3>
            <p>amittes@gmail.com</p>

            <h3>Working Hours:</h3>
            <p>24/7</p>

            <h3>Connect with Us:</h3>
            <p>Follow us on social media for the latest updates and announcements:</p>
            {/* Add social media icons or links as needed */}

            {/* Add any other contact information or forms as necessary */}
    </div>
);

export default ContactContent;
